import { defineMessages } from 'react-intl';

export const confluenceExtensionMessages: {
	extensionDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	extensionTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	extensionTitle: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.title',
		defaultMessage: 'Create Confluence page',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	extensionDescription: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.description',
		defaultMessage: 'Create a new page and insert it as a link',
		description: 'Message that elaborates on the title for the quick insert option',
	},
});
